import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from 'react-router';
import { MenuListContainer, UserTrigger, DropdownMenu, DropdownIcon, UserInfo, } from "./MenuList.style";
import ChevronRightIcon from "../../../assets/icons/ChevronRightIcon";
import CloseIcon from "../../../assets/icons/CloseIcon";
import BackIcon from "../../../assets/icons/BackIcon";
import LogoutIcon from "../../../assets/icons/LogoutIcon";
const MenuList = ({ children, dropdownItems, onItemClick, className, name, email, fullScreen = false, hasLogout = false, inverse = false, onLogout, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
    const menuRef = useRef(null);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobileOrTablet(window.innerWidth < 1280);
        };
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        return () => {
            window.removeEventListener("resize", checkScreenSize);
        };
    }, []);
    const handleTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientY);
    };
    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientY);
    };
    useEffect(() => {
        const menuElement = menuRef.current;
        const handleTouchEnd = () => {
            if (!touchStart || !touchEnd)
                return;
            const distance = touchEnd - touchStart;
            const isDownSwipe = distance > 50;
            if (isDownSwipe && isMobileOrTablet) {
                setIsOpen(false);
            }
        };
        if (isOpen && isMobileOrTablet && menuElement) {
            menuElement.addEventListener("touchstart", handleTouchStart, {
                passive: true,
            });
            menuElement.addEventListener("touchmove", handleTouchMove, {
                passive: true,
            });
            menuElement.addEventListener("touchend", handleTouchEnd, {
                passive: true,
            });
        }
        return () => {
            if (menuElement) {
                menuElement.removeEventListener("touchstart", handleTouchStart);
                menuElement.removeEventListener("touchmove", handleTouchMove);
                menuElement.removeEventListener("touchend", handleTouchEnd);
            }
        };
    }, [isOpen, isMobileOrTablet, touchStart, touchEnd]);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const handleItemClick = (item) => {
        if (item.onClick) {
            item.onClick();
        }
        if (onItemClick) {
            onItemClick(item);
        }
        setIsOpen(false);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen]);
    const buildUrlWithReferrer = (originalPath) => {
        let url = originalPath;
        url = url.replace("{REFERRER_NAME}", encodeURIComponent("o Portal Sebrae"));
        url = url.replace("{URL}", encodeURIComponent(window.location.href));
        return url;
    };
    return (_jsxs(MenuListContainer, { ref: menuRef, className: className, children: [_jsxs(UserTrigger, { onClick: toggleDropdown, className: isOpen ? "active" : "", "aria-expanded": isOpen, "aria-haspopup": "menu", "$inverse": inverse, children: [children, _jsx(DropdownIcon, { className: `dropdown-icon ${isOpen ? "active" : ""}`, "$inverse": inverse, children: _jsx(ChevronRightIcon, {}) })] }), _jsxs(DropdownMenu, { className: `${isOpen ? "active" : ""} ${fullScreen ? "fullscreen" : ""}`, role: "menu", "$fullScreen": fullScreen, children: [(name || email) && (_jsxs(UserInfo, { "$fullScreen": fullScreen, children: [fullScreen && (_jsx("button", { type: "button", className: "close-button", onClick: () => setIsOpen(false), "aria-label": "Fechar menu", children: _jsx(BackIcon, {}) })), _jsxs("div", { className: "user-content", children: [name && _jsxs("div", { className: "user-name", children: ["Ol\u00E1, ", name, "!"] }), email && _jsx("div", { className: "user-email", children: email })] }), !fullScreen && isMobileOrTablet && (_jsx("button", { type: "button", className: "close-button", onClick: () => setIsOpen(false), "aria-label": "Fechar menu", children: _jsx(CloseIcon, {}) }))] })), _jsxs("ul", { children: [dropdownItems.map((item, index) => {
                                const itemKey = item.id || `item-${index}`;
                                const isLogoutItem = item.label.toLowerCase() === "sair";
                                if (item.path) {
                                    return (_jsxs(React.Fragment, { children: [_jsx("li", { className: "menu-item", children: _jsxs("a", { href: buildUrlWithReferrer(item.path), target: item.targetBlank ? "_blank" : "_self", rel: item.targetBlank ? "noreferrer" : undefined, className: "menu-link", role: "menuitem", onClick: (e) => {
                                                        if (!item.targetBlank && item.path && item.path.startsWith('/')) {
                                                            e.preventDefault();
                                                            navigate(item.path);
                                                        }
                                                        handleItemClick(item);
                                                    }, children: [isLogoutItem && _jsx(LogoutIcon, { width: "14", height: "14" }), _jsx("span", { className: "menu-item-title", children: item.label })] }) }), item.separator && _jsx("li", { className: "separator" })] }, itemKey));
                                }
                                return (_jsxs(React.Fragment, { children: [_jsx("li", { className: "menu-item", children: _jsxs("button", { type: "button", onClick: () => handleItemClick(item), className: "menu-button", role: "menuitem", children: [isLogoutItem && _jsx(LogoutIcon, { width: "14", height: "14" }), _jsx("span", { className: "menu-item-title", children: item.label })] }) }), item.separator && _jsx("li", { className: "separator" })] }, itemKey));
                            }), hasLogout && (_jsx("li", { className: "menu-item", children: _jsxs("button", { type: "button", onClick: onLogout, className: "menu-button", role: "menuitem", children: [_jsx(LogoutIcon, {}), _jsx("span", { className: "menu-item-title", children: "Sair" })] }) }))] })] })] }));
};
export default MenuList;
//# sourceMappingURL=MenuList.js.map